<template>
    <div class="about-page body-box">
        <div class="hero-header">
            <h3 class="title-with-dot">{{ sectionTitle }}</h3>
        </div>

		<div class="about-content-body">
			<div class="about-content-body-inner">
					
				<h1>{{ aboutData.name }}</h1>
				<p>{{ aboutData.bio }}</p>
				<img class="about-img" :src="aboutData.img" alt="About"/>


				<div class="about-content-body-inside-2">
					<h2>{{ aboutData.title }}</h2>
					<p>{{ aboutData.content }}</p>
					<p>{{ aboutData.content2 }}</p>
				</div>

				<div class="about-content-body-inside-3">
					<h2>{{ aboutData.title2 }}</h2>
					<p>{{ aboutData.content3 }}</p>
				</div>
			</div>

			<div class="projects-list products-list">
				<project-item className="product" iconName="la-arrow-right" :item="product" v-for="(product, i) in products" :key="i" />

			</div>

		</div>

		<news-letter />

		<ohilo-footer />
    </div>
</template>

<script>
import ProjectItem from '@/components/modules/ProjectItem.vue';
import NewsLetter from '@/components/sections/NewsLetter.vue';
import OhiloFooter from '@/components/common/OhiloFooter.vue';

export default {
    name: "AboutView",
    components: {
		ProjectItem,
        NewsLetter,
        OhiloFooter
	},
    data() {
        return {
			sectionTitle: 'About',
			aboutData: {
				name: 'It\'s Me Tanbir',
				bio: 'I\'m Tanbir Do, a product designer with over 5 years of experience, currently residing in Jakarta, Indonesia. I have a deep passion for crafting purposeful interfaces and products. My main goal is to bridge the divide between people and technology, transforming intricate challenges into meaningful and seamless experiences.',
				img: require('@/assets/images/about-img.jpg'),
				title: 'More About Me',
				content: 'Tanbir Do holds a bachelor\'s degree in Graphic Design from a prestigious university in the United States and has a relentless drive for staying up-to-date with the latest technologies and design trends. Actively involved in the design community, Tanbir regularly participates in diverse design conferences and meetups.',
				content2: 'When he\'s not immersed in design work, he finds solace in playing the guitar and exploring new coffee shops in his local area. Tanbir firmly believes in maintaining a healthy work-life balance, making sure to take breaks and reenergize his creativity. In his spare time, he also volunteers at a local animal shelter on weekends.',
				title2: 'My Side Projects',
				content3: 'I did passion side projects in the weekend, please take a look you will love it (i hope).'
			},
            products: [
                {
                    img: require('@/assets/images/project1.jpg'),
                    title: 'Seven Studio'
                },
                {
                    img: require('@/assets/images/project2.jpg'),
                    title: 'Raven Studio'
                },
                {
                    img: require('@/assets/images/me.png'),
                    title: 'Ohilo'
                }
            ]
        }
    }
};
</script>